import axios from 'axios'
import React, { useEffect, useState } from 'react'
import {
  Container,
  Card,
  Table,
  Button,
  Modal,
  Row,
  Col,
} from 'react-bootstrap'
import toast from 'react-hot-toast'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Cookies from 'js-cookie'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'


const RegisteredBrokerList = ({ newBroker }) => {
  const [brokers, setBrokers] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  // Fetch transactions when booking_id changes
  const buttonStyle = {
    transition: 'transform 0.3s ease',
  }
  const buttonHoverstyle = {
    transform: 'scale(1.2)',
  }
  useEffect(() => {
    const fetchBrokerssData = async () => {
      setLoading(true)

      const token = Cookies.get('authToken') // Retrieve token from cookies

      try {
        const response = await axios.get(
          BASE_URL+'/brokers/search',

          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: 'application/json',
            },
          },
        )
        if (response.data.data && response.data.data.length === 0) {
          setBrokers([])
        } else {
          console.log('associate data', response.data.data)
          setBrokers(response.data.data)
        }
      } catch (err) {
        toast.error(err.response?.data?.message || 'No Bookings are available ')
      } finally {
        setLoading(false)
      }
    }
    fetchBrokerssData()
  }, [])

  const [isHovered, setIsHovered] = useState(false)
  const [selectedBroker, setSelectedBroker] = useState(null)
  const [visibleModal, setVisibleModal] = useState(false)

  const handleModal = (broker) => {
    console.log('Opening modal for broker:', broker)
    setSelectedBroker(broker)
    setPassword('')
    setConfirmPassword('')
    setVisibleModal(true)
  }

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [displayedPassword, setDisplayedPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  useEffect(() => {
    console.log('useEffect triggered:', { visibleModal, selectedBroker })
    if (visibleModal && setSelectedBroker.id) {
      console.log('Setting email and clearing password/confirmPassword') // Debugging line
      setEmail(selectedBroker?.email || '')
      setPassword('')
      setConfirmPassword('')
      setSelectedBroker(null)
    }
  }, [visibleModal, selectedBroker])

  const [showModalMessage, setShowModalMessage] = useState(false)
  const handleFormSubmit = async (e) => {
    e.preventDefault()
    console.log('Form submitted')
    if (!selectedBroker?.broker_id) {
      toast.error('Associate ID is missing. Please select a valid associate.')
      console.log('No assiciate selected')
      return
    }

    if (!password) {
      toast.error('Please enter your password.')
      console.log('No password entered')
      return
    }

    if (!confirmPassword) {
      toast.error('Please confirm your password.')
      console.log('No confirm password entered')
      return
    }
    if (password !== confirmPassword) {
      toast.error('Password does not match.')
      console.log('Passwords do not match')
      return
    }

    setLoading(true)
    console.log('Sending credentials request')

    const token = Cookies.get('authToken')

    try {
      const credentialsRes = await axios.post(
        BASE_URL+'/broker/signup', // Use only base URL without query params
        {
          broker_id: selectedBroker.broker_id, // Send broker_id in the request body
          password: password, // Send password in the body
          email: email, // Send email in the body
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      )
      console.log('Credential Response: ', credentialsRes)

      if (credentialsRes.status == 200 && credentialsRes.data.status == 200) {
        setDisplayedPassword(password)
        setShowModalMessage(credentialsRes.data.message)
        setVisibleModal(false)
      } else {
        setShowModalMessage(
          credentialsRes.data.message || 'Failed to create credential',
        )
        setVisibleModal(false)
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Unexpected error occurred'
      console.log('Error during create credential:', errorMessage)
      setShowModalMessage(errorMessage)
      setVisibleModal(false)
    } finally {
      setLoading(false)
    }
  }
  const handleCloseButton = () => {
    setShowModalMessage(false)
  }
  const handleBackButton = () => {
    setShowModalMessage(false)
    setVisibleModal(true)
  }

  return (
    <Container
      fluid className="px-3 pb-3"
    >

      
      {/* <Card className="p-3 shadow-sm rounded-3"> */}
        {/* <Card.Header className=" text-success text-center bg-light">
          <h2 className="mb-2  fw-bold">Our Associates</h2>
        </Card.Header> */}


        <div className='px-3 mb-3' style={{ backgroundColor: theme.colors.background }}>

        {/* <Card.Body> */}
          {/* Display Entered Password */}
          {displayedPassword && (
            <div className="alert alert-info mt-0">
              <strong>Your Password is "</strong> {displayedPassword}{' '}
              <strong>". Please note it.</strong>
            </div>
          )}
          <Table
            hove
            bordered
            responsive="md"
            className="text-center table table-bordered table-hover"
          >
            <thead className="position-sticky top-0  text-start">
                <tr className="text-start">
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Associate Id</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Name</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Email</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Phone Number</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>ID Type</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>ID Number</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Associate's Level</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>My Customer's Bookings</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Action</th>
                </tr>
                
            </thead>
            <tbody className="text-start">
              {/* Conditionally render a message  */}
              {loading ? (
                <tr>
                  <td colSpan={9} className="text-center">
                    Loading associates...
                  </td>
                </tr>
              ) : brokers.length === 0 ? (
                <tr>
                  <td colSpan={9} className="text-center text-danger ">
                    No associates are available
                  </td>
                </tr>
              ) : null}
              {brokers.map(
                (broker) =>
                  broker.name != null && (
                    <tr key={broker._id}>
                      <td>{broker.broker_id}</td>
                      <td>{broker.name}</td>
                      <td>{broker.email}</td>
                      <td>{broker.phone_number}</td>
                      <td>{broker.id_type}</td>
                      <td>{broker.id_number}</td>
                      <td>{broker.broker_level} </td>
                      <td>
                        <Link
                          to={`/associatebookingsdetails/${broker.broker_id}`}
                        >
                          Click
                        </Link>
                      </td>
                      <td>
                        <div>
                          <Button
                            variant="outline-success"
                            className="btn-sm me-4 m-1"
                            title="Edit Associate"
                            onClick={() =>
                              (window.location.href = `/updateassociate/${broker.broker_id}`)
                            }
                            style={
                              isHovered?.broker_id === broker.broker_id &&
                              isHovered?.type === 'edit'
                                ? { ...buttonStyle, ...buttonHoverstyle }
                                : buttonStyle
                            }
                            onMouseEnter={() =>
                              setIsHovered({
                                broker_id: broker.broker_id,
                                type: 'edit',
                              })
                            }
                            onMouseLeave={() => setIsHovered(null)}
                          >
                            <i className="fa-solid fa-pen-to-square"></i>
                          </Button>
                        </div>

                        <div>
                          <Button
                            variant="outline-primary"
                            className=" btn-sm me-4 m-1"
                            title="See Payment History"
                            onClick={() => {
                              console.log(
                                `Navigating to /associatepayment/${broker.broker_id}`,
                              )

                              navigate(`/associatepayment/${broker.broker_id}`)
                            }}
                            style={
                              isHovered?.broker_id === broker.broker_id &&
                              isHovered?.type === 'see'
                                ? { ...buttonStyle, ...buttonHoverstyle }
                                : buttonStyle
                            }
                            onMouseEnter={() =>
                              setIsHovered({
                                broker_id: broker.broker_id,
                                type: 'see',
                              })
                            }
                            onMouseLeave={() => setIsHovered(null)}
                          >
                            <i class="fas fa-eye"></i>
                          </Button>
                        </div>
                        <div>
                          <Button
                            variant="outline-dark"
                            className="btn-sm me-4 m-1"
                            title="Create Credential"
                            onClick={() => handleModal(broker)}
                            style={
                              isHovered?.broker_id === broker.broker_id &&
                              isHovered?.type === 'sign'
                                ? { ...buttonStyle, ...buttonHoverstyle }
                                : buttonStyle
                            }
                            onMouseEnter={() =>
                              setIsHovered({
                                broker_id: broker.broker_id,
                                type: 'sign',
                              })
                            }
                            onMouseLeave={() => setIsHovered(null)}
                          >
                            <i class="fa-solid fa-user"></i>
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ),
              )}
            </tbody>
          </Table>
        {/* </Card.Body> */}

        {/* Pop up Modal for Creating Credential */}
        <Modal
          show={visibleModal}
          onHide={() => setVisibleModal(false)}
          centered
          size="xxl"
        >
          <Modal.Header closeButton>
            <div className="w-100 text-center">
              <Modal.Title className="fw-bold" style={{ color: theme.colors.primary }}>
                {`Create Credential for associate  ${
                  selectedBroker?.name?.toUpperCase() || ''
                }`}
              </Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body className="text-center p-4">
            {/* Profile Image */}
            <div className="mb-4">
              <img
                src="/avtar-profile.png"
                alt="User Avatar"
                className="rounded-circle shadow"
                style={{ width: '120px', height: '120px' }}
              />
            </div>
            {/* Form Fields */}
            <Row className="mb-3">
              <Col>
                <div className="input-group">
                  <span className="input-group-text bg-light">
                    <i className="fa fa-envelope"></i>
                  </span>
                  <input
                    type="email"
                    className="form-control"
                    value={selectedBroker?.email || ''}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled
                  />
                </div>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col>
                <div className="input-group">
                  <span className="input-group-text bg-light">
                    <i className="fa fa-lock"></i>
                  </span>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className="form-control"
                    value={password || ''}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter Your Password"
                  />
                  <span
                    className="input-group-text bg-white"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ cursor: 'pointer' }}
                  >
                    <i
                      className={`fa ${
                        showPassword ? 'fa-eye-slash' : 'fa-eye'
                      }`}
                    ></i>
                  </span>
                </div>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col>
                <div className="input-group">
                  <span className="input-group-text bg-light">
                    <i className="fa fa-lock"></i>
                  </span>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Re-Enter Your Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            {/* Login Button */}
            <Button
              
              className="w-100 fw-bold"
              onClick={handleFormSubmit}
              style={{backgroundColor: theme.colors.primary, color:theme.colors.background, border:'none'}}
              disabled={loading}
            >
              {loading ? 'Creating...' : 'Create Credential'}
            </Button>
          </Modal.Body>
        </Modal>

        <Modal
          show={showModalMessage}
          onHide={() => setShowModalMessage(false)}
          centered
          size="xxl"
        >
          <Modal.Title style={{ margin: '1rem' }}>
            <Button variant="outline-success" onClick={handleBackButton}>
              <i
                className="fa fa-arrow-left"
                style={{ fontSize: '1rem', marginRight: '8px' }}
              ></i>
              Go to back
            </Button>
          </Modal.Title>
          <Modal.Body
            className=" d-flex justify-content-center"
            style={{
              marginBottom: '1rem',
            }}
          >
            {showModalMessage}
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <Button variant="outline-danger" onClick={handleCloseButton}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        </div>
      {/* </Card> */}
    </Container>
  )
}

export default RegisteredBrokerList
